import API_BASE_URL from "../utils/config";
import request from "../utils/request";
import { v4 as uuidv4 } from "uuid";

export async function postSection(data) {
  const url = `${API_BASE_URL}/sections`;
  return request({
    url,
    method: "post",
    data,
  });
}

export async function fetchAllSection(data) {
  const url = `${API_BASE_URL}/sections`;
  return request({
    url,
    method: "get",
    data,
  });
}

export async function getSectionById(id) {
  const url = `${API_BASE_URL}/sections/${id}`;
  return request({
    url,
    method: "get",
  });
}

export async function postEdit(data) {
  const { id } = data;
  const url = `${API_BASE_URL}/sections/${id}`;
  // const formData = toFormData(data);

  return request({
    url,
    method: "put",
    data,
    // // upload: true,
    // // config: {
    // //   headers: {
    // //     "content-type": "multipart/form-data",
    // //   },
    // },
  });
}

export async function deleteSectionById(id) {
  const url = `${API_BASE_URL}/sections/${id}`;
  return request({
    url,
    method: "delete",
  });
}

export async function httpCreateSectionImage(data) {
  const modData = { image: data, name: uuidv4() };
  const url = `${API_BASE_URL}/images`;
  const formData = toFormData(modData);
  return request({
    url,
    method: "post",
    formData,
    upload: true,
    config: {
      headers: {
        "content-type": "multipart/form-data",
      },
    },
  });
}

function toFormData(data) {
  const formData = new FormData();
  formData.append("file", data.image);
  formData.append("name", data.name);
  return formData;
}
